export default "__VITE_ASSET__gsv6ob6icZuqjPfpD2W2Qw__"